import _ from 'lodash';

const editAttrs = [
  'logoPath',
  'lovedNonprofitIds',
  'volEventIds',
  'campaignIds',
  'employeesCanView',
  'linkCanView',
  'showSectionMatch',
  'showSectionVolunteer',
  'showSectionGrant',
  'showSectionGift',
  'showCustomerGifts',
  'showEmployeeGifts',
  'missionText',
  'programDetailsText',
  'hasSocialFeed',
  'givingYearGoalMap',
  'showTotalMatch',
  'showTotalVolunteer',
  'showTotalGrant',
  'showTotalGift',
  'showTotalCombined',
  'hideMatchLanguage',
  'defaultRangeAll',
];

// returns the goal for the given year
// if given year has no goal value, returns goal of most recent year that does
const goalForYear = (yearGoalMap, year) => {
  const years = _.sortBy(Object.entries(yearGoalMap).map(e => parseInt(e[0]))).reverse();
  const useYear = years.find(y => y <= year && _.isFinite(yearGoalMap[y]));
  const goal = yearGoalMap[useYear];
  return _.isFinite(goal) ? goal : null;
};

// builds a yearGoalMap object with missing years filled in
const expandedYearGoalMap = (yearGoalMap, manageableYears) => {
  const map = {...yearGoalMap};
  manageableYears.forEach((my) => {
    const goal = goalForYear(yearGoalMap, my.year) || 0;
    map[my.year] = goal;
  });
  return map;
};

export {
  editAttrs,
  goalForYear,
  expandedYearGoalMap,
};

export default {
  editAttrs,
  goalForYear,
  expandedYearGoalMap,
};
